import { CommonModule } from '@angular/common';
import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonRow,
  IonTitle,
  IonToolbar,
  LoadingController,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MessagesUiService } from '@okcargo-apps/messages-ui';
import { FreightAvailableMutationsService } from '../freight-available-mutations.service';
import { IFreightAvailableDetailed } from '@okcargo-apps/shared-domain';
import { AnalyticsService } from '@okcargo-apps/shared-infrastructure-ionic';
import { DateFnsModule } from 'ngx-date-fns';
import { FreightAvailableDetailModalDataComponent } from '../freight-available-detail-modal-data/freight-available-detail-modal-data.component';

@Component({
  selector: 'lib-freight-available-interested-modal',
  templateUrl: './freight-available-interested-modal.component.html',
  styleUrls: ['./freight-available-interested-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    IonGrid,
    IonRow,
    IonCol,
    IonContent,
    IonFooter,
    IonTitle,
    IonIcon,
    IonButton,
    IonButtons,
    IonToolbar,
    IonHeader,
    DateFnsModule,
    TranslateModule,
    FreightAvailableDetailModalDataComponent,
  ],
})
export class FreightAvailableInterestedModalComponent implements OnInit {
  // comes from the component that opens the modal
  public freight!: IFreightAvailableDetailed;

  private readonly freightAvailableMutationsService = inject(FreightAvailableMutationsService);
  private readonly modalCtrl = inject(ModalController);
  private readonly loadingCtrl = inject(LoadingController);
  private readonly translate = inject(TranslateService);
  private readonly analyticsService = inject(AnalyticsService);
  private readonly messagesService = inject(MessagesUiService);

  ngOnInit(): void {
    this.analyticsService.logEvent('interested_on_freight_view');
  }

  public cancel(): Promise<boolean> {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  public async confirm(): Promise<boolean | undefined> {
    const loading = await this.loadingCtrl.create({
      message: this.translate.instant('general.send_data'),
    });
    loading.present();

    try {
      await this.freightAvailableMutationsService.showInterestOnFreight(this.freight.id).then(() => {
        this.messagesService.setMessage({
          objectId: this.freight.id,
          message: [this.translate.instant('market.show_interest')],
        });
      });

      this.analyticsService.logEvent('interested_on_freight_sent');
      return this.modalCtrl.dismiss(null, 'confirm');
    } catch (error) {
      console.error('Error file:', error);
      return this.modalCtrl.dismiss(null, 'confirm');
    } finally {
      await loading.dismiss();
    }
  }
}
